import * as React from 'react';
import { EHouseSorting, HOUSE_SORTINGS_MAP } from '../../../constants/sort';
import { IHouse } from '../../../types/newbuilding/house';

export function useHouseSorting(array: IHouse[], defaultSorting: EHouseSorting = EHouseSorting.Offers) {
  const [sorting, setSorting] = React.useState(defaultSorting);
  const [sortedArray, setSortedArray] = React.useState(array);

  const changeSorting = React.useCallback((value: EHouseSorting) => setSorting(value), [setSorting]);

  React.useEffect(() => {
    const sorter = HOUSE_SORTINGS_MAP[sorting];
    if (!sorter) {
      return;
    }

    const newArray = array.sort(sorter);
    setSortedArray([...newArray]);
  }, [sorting, setSortedArray, array]);

  return { sorting, sortedArray, changeSorting };
}
